'use client';

import { useCallback, useEffect, useRef } from 'react';

const useDefer = () => {
  const countRef = useRef(0);
  const animationRef = useRef<number | null>(null);

  const update = useCallback(() => {
    if (countRef.current >= 100) return;

    countRef.current += 1;
    animationRef.current = requestAnimationFrame(update);
  }, []);

  useEffect(() => {
    update();
  });

  useEffect(() => {
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return function (n: number) {
    return countRef.current >= n; // 返回一个函数，用于判断是否渲染组件
  };
};

export default useDefer;
